var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("label",[(_vm.label)?_c('CoLabel',{staticClass:"d-block",attrs:{"text":_vm.label}}):_vm._e()]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }